function initializeModals() {

    console.log('start drop');

    let $AcHead = $('.accordion .head'),
        $drop = $('.drop'),
        $head = $drop.find('.head');

    if ($('.drop .toggle')[0]) { //dropdown
        $drop.find('.toggle').on('shown.bs.dropdown', function (e) {
            $(this).parent().addClass('open');
            console.log($(this).parents('.box-form').length);
            if ($(this).parents('.box-form').length > 0) {
                $(this).parents('.box-form').addClass('hover');
            }
        })
        $drop.find('.toggle').on('hide.bs.dropdown', function (e) {
            $(this).parent().removeClass('open');
            // console.log($(this).parents('.box-form'));
            if ($(this).parents('.box-form').length > 0) {
                $(this).parents('.box-form').removeClass('hover');
            }
        })

        $drop.find('.toggle').click(function (e) {
            ($(this).parent().hasClass('open')) ? $(this).trigger('hide.bs.dropdown') : $(this).trigger('shown.bs.dropdown')
        })
    }

    if ($('.drop .head')[0]) { // accardion
        $head.parent().each(function () {
            $(this).hasClass('open') ? $(this).css({ '--h': `${$(this).find('.body').innerHeight()}px` }) : $(this).css({ '--h': 0 });
            console.log($(this).find('.body').innerHeight(), $(this));
        })
        $head.click(function () {
            $(this).parent().hasClass('open') ? $(this).trigger('hide.bs.accardion') : $(this).trigger('shown.bs.accardion');
        })
        $head.on('shown.bs.accardion', function (e) {
            $(this).parent().addClass('open').css({ '--h': `${$(this).parent().find('.body').innerHeight()}px` });
        })
        $head.on('hide.bs.accardion', function (e) {
            $(this).parent().removeClass('open').css({ '--h': 0 });
        })
    }

    if ($('.head[data-target]')[0]) { //modal
        setTimeout(() => {
            $AcHead.each(function () {
                let tr = $(this).data('target');
                $(tr).hasClass('open') ? $(tr).css({ '--h': `${$(tr).find('.body').innerHeight()}px` }) : $(tr).css({ '--h': 0 });
            })
        }, 0)


        $AcHead.click(function () {
            $($(this).data('target')).hasClass('open') ? $(this).trigger('hide.bs.target') : $(this).trigger('shown.bs.target');
        })

        $AcHead.on('shown.bs.target', function () {
            let tr = $(this).data('target');

            if (tr) {
                $(tr).addClass('open').css({ '--h': `${$(tr).find('.body').innerHeight()}px` });
                $(this).addClass('open');
            }
        })

        $AcHead.on('hide.bs.target', function () {
            $($(this).data('target')).css({ '--h': 0 }).removeClass('open');
            $(this).removeClass('open');
        })

    }

    let btnTarg = $('.dt[data-target],.btn[data-target]');
    if (btnTarg[0]) {
        btnTarg.click(function () {
            let $modal = $(this).data('target');
            $($modal).addClass('open');
            $($body).addClass('modal-open');
        })
    }

    $('.modal .close').on('click', function () {
        $(this).parents('.modal').removeClass('open');
        $($body).removeClass('modal-open');
    })

    $('.modal').on('click', function (event) {
        if (event.target.matches('.modal')) {
            $('.modal').each(function () {
                $(this).removeClass('open');
                $($body).removeClass('modal-open');
            })
        }
    });

    // $('.modal-content').on('click',function(event) {
    //     event.stopPropagation();
    // });

    // Adding a click event listener to the tab items
    $(document).on(
        "click",
        ".nav-tabs .item[data-target]:not([disabled]):not(.disabled)",
        function () {
            let $tabCont = $(this).data("target");

            $(this).closest(".nav-tabs").find(".item").removeClass("active");

            $(this).addClass("active");

            $($tabCont).closest(".tab-cont").find(".item").removeClass("open");

            $($tabCont).addClass("open");
        }
    );

    // Close the dropdown if the user clicks outside of it
    window.onclick = function (event) {
        if (!event.target.matches('.toggle')) {
            // console.log($(event.target));
            $('.drop.wb .in').each(function () {
                $(this).parent().removeClass('open');
                $(event.target).parents('.box-form').find('.toggle').trigger('hide.bs.dropdown');
                if ($(this).parents('.box-form').length > 0) {
                    $(this).parents('.box-form').removeClass('hover');
                }
            })
        }
    }

    initializeValdrop();

};

// Call the modal initialization once
if (PAGE_ID !== '2344149700' && PAGE_ID !== '3824005525') {
    initializeModals();
}
